import {createSlice} from "@reduxjs/toolkit";

const imageSlice = createSlice({
  name: 'image',
  initialState: {
    src: '',
    isRemove: false,
  },
  reducers: {
    setImage: (state, action) => {
      state.src = action.payload.src;
    },
    setIsRemove: (state, action) => {
      state.isRemove = action.payload.isRemove;
      if (!action.payload.isRemove) state.src = '';
    }
  },
});

export default imageSlice.reducer;
export const {setImage, setIsRemove} = imageSlice.actions;
